// Shorter terms make the API's Elasticsearch wildcard search scan the whole purchase index
export const MIN_PURCHASE_SEARCH_LENGTH = 3;

export const getPurchaseSearchTerm = (search: string) => {
    const term = search.trim();

    return term.length >= MIN_PURCHASE_SEARCH_LENGTH ? term : undefined;
};
